import { Injectable } from '@angular/core';
import { CertificateName } from '../main/employees/domain/certificate-name';
import { environment } from '../../environments/environment';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CertificateNameService {
  private certificatesRefresh = new BehaviorSubject<void>(undefined);
  private certificatesRefresh$ = this.certificatesRefresh.asObservable();

  readonly allWithRemovedCertificates$: Observable<CertificateName[]> = this.certificatesRefresh$.pipe(
      switchMap(() => this.http.get<CertificateName[]>(`${environment.api}/certificate-names`)),
      shareReplay(1),
  );

  readonly currentCertificates$: Observable<CertificateName[]> = this.allWithRemovedCertificates$.pipe(
      map((certificates) => certificates.filter((certificate) => !certificate.isRemoved)),
  );

  constructor(private http: HttpClient) {}

  refreshCertificates(): void {
    this.certificatesRefresh.next();
  }

  addCertificate(newCertificate: CertificateName): Observable<{ msg:string }> {
    return this.http.post<{ msg:string }>(`${environment.api}/admin/certificate-name`, newCertificate);
  }

  editCertificate(certificateId: number, editedCertificate: CertificateName): Observable<{}> {
    return this.http.put(`${environment.api}/admin/certificate-name/${certificateId}`, editedCertificate);
  }

  removeCertificate(certificateId: number): Observable<{}> {
    return this.http.delete(`${environment.api}/admin/certificate-name/${certificateId}`);
  }
}
